var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webdatalist" }, [
    _c(
      "div",
      { staticClass: "showLargeScreenOnly" },
      [
        _c(
          "f7-list",
          {
            staticClass: "searchbar-found",
            attrs: { "media-list": "", id: "group-list" },
          },
          _vm._l(_vm.filteredUserAccounts, function (group, key) {
            return _c(
              "f7-list-group",
              { key: key },
              [
                _c("f7-list-item", {
                  attrs: { title: key, "group-title": "" },
                }),
                _vm._v(" "),
                _vm._l(group, function (membersGroup) {
                  return _c("li", { key: membersGroup.id }, [
                    _c("div", { staticClass: "item-content boxRequest" }, [
                      _c(
                        "div",
                        {
                          staticClass: "item-inner",
                          on: {
                            click: function ($event) {
                              return _vm.editContactGroup(membersGroup)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "item-title" }, [
                            _vm._v(_vm._s(membersGroup.name)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-media" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button-swipe-out",
                            attrs: { disabled: !_vm.canDeleteGroup },
                            on: {
                              click: function ($event) {
                                return _vm.deleteTeamWeb(membersGroup)
                              },
                            },
                          },
                          [
                            _c("f7-icon", {
                              staticClass: "button-delete",
                              style: _vm.canDeleteGroup
                                ? {}
                                : { color: "grey" },
                              attrs: { f7: "close" },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ])
                }),
              ],
              2
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "showSmallScreenOnly" },
      [
        _c(
          "f7-list",
          {
            staticClass: "searchbar-found",
            attrs: { "media-list": "", id: "group-list" },
          },
          _vm._l(_vm.filteredUserAccounts, function (group, key) {
            return _c(
              "f7-list-group",
              { key: key },
              [
                _c("f7-list-item", {
                  attrs: { title: key, "group-title": "" },
                }),
                _vm._v(" "),
                _vm._l(group, function (membersGroup) {
                  return _c(
                    "f7-list-item",
                    {
                      key: membersGroup.id,
                      staticClass: "boxRequest",
                      attrs: { swipeout: "", title: membersGroup.name },
                      on: {
                        "swipeout:deleted": function ($event) {
                          return _vm.deleteTeam(membersGroup)
                        },
                        click: function ($event) {
                          return _vm.editContactGroup(membersGroup)
                        },
                      },
                    },
                    [
                      _c(
                        "f7-swipeout-actions",
                        [
                          _c(
                            "f7-swipeout-button",
                            {
                              staticClass: "swipeout-create action3",
                              attrs: {
                                href: "/accountMembers/addMemberGroup/",
                                close: "",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("rights.edit")))]
                          ),
                          _vm._v(" "),
                          _c("f7-swipeout-button", { attrs: { delete: "" } }, [
                            _vm._v(_vm._s(_vm.$t("common.rm_label"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }